import data from "../../../../data/schema/shared/sharedData";

const fieldsToClearAppAB = [
  "appAEduOther",
  "appAEduMajors",
  "appAEduInstName",
  "appAEduCountryId",
  "appAEduMonthYearAttained",
];

const fieldsToClearAppAC = [
  "appATrainingName",
  "appATrainingCert",
  "appATrainingStartDate",
  "appATrainingEndDate",
  "appATrainingYearAwd",
];

const fieldsToClearAppAD = [
  "appASkillsCountryId",
  "appASkillsStateId",
  "fwTerritory",
  "appASkillsSpecial",
];

const fieldsToClearAppAE = [
  "appAExpAddress1",
  "appAExpAddress2",
  "appAExpCity",
  "appAExpPostalCode",
  "appAExpCountryId",
  "appAExpStateTerritory",
  "appAExpProvince",
  "appAExpJobTitle",
  "appAExpStartDate",
  "appAExpEndDate",
  "appAExpFWPresent",
  "appAExpWorkHour",
  "appAExpJobDuties",
];

export default {
  name: "Foreign Worker Profile",
  sections: [
    {
      name: "Name",
      fields: [
        {
          code: "A.1",
          machine_name: "new_profile_fw_last",
          widget: "text",
          label: "Last (Family) Name",
          validate: [
            "required",
            "noNAs",
            {
              minLength: 2,
              message: "Last Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip: `Enter the last (family) name of the foreign worker.  If the foreign worker has only one name, enter the name in this field and enter “FNU” (first name unknown) in the first name field.`,
        },
        {
          code: "A.2",
          machine_name: "new_profile_fw_first",
          widget: "text",
          label: "First (Given) Name",
          validate: [
            "required",
            "noNAs",
            {
              minLength: 2,
              message: "First Name must contain at least 2 characters",
            },
          ],
          maxLength: 35,
          tooltip:
            "Enter the first (given) name of the foreign worker.  If the foreign worker has only one name, enter “FNU” (first name unknown) in this field.",
        },
        {
          code: "A.3",
          machine_name: "new_profile_fw_middle",
          widget: "text",
          label: "Middle Name(s)",
          validate: ["required"],
          maxLength: 35,
          tooltip: `Enter the full middle name of the foreign worker.  If the foreign worker does not have a middle name, enter “N/A.”`,
        },
      ],
    },
    {
      name: "Address",
      fields: [
        {
          code: "A.4",
          machine_name: "new_profile_fw_address",
          widget: "text",
          label: "Address 1 (current)",
          validate: [
            "required",
            "noNAs",
            {
              minLength: 2,
              message: `Address 1 must contain at least 2 characters.`,
            },
          ],
          maxLength: 120,
          tooltip:
            "Enter the street address of the foreign worker’s current residence.",
        },
        {
          code: "A.5",
          machine_name: "new_profile_fw_address2",
          widget: "text",
          label:
            "<span>Address 2 <i>(apartment/suite/floor and number)</i>  §</span>",
          maxLength: 35,
          tooltip: `If additional space is needed for the street address, use this line.  If no additional space is needed, enter “N/A.”`,
        },
        {
          code: "A.9",
          machine_name: "new_profile_fw_country",
          widget: "select",
          label: "Country",
          selection: data.country,
          validate: ["required"],
          clearSchema: ["new_profile_fw_state", "new_profile_fw_province"],
          tooltip:
            "Enter the country of the foreign worker’s current residence. If the city and country of residence are the same, the name <u>must</u> still be entered in <u>both</u> fields.",
        },
        {
          code: "A.6",
          machine_name: "new_profile_fw_city",
          widget: "text",
          label: "City",
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
            "noNAs",
          ],
          maxLength: 35,
          tooltip: `Enter the city of the foreign worker’s current residence.  If the city and country of 
            residence are the same, the name <u>must</u> still be entered in <u>both</u> fields.`,
          disabled: true,
          disableWhenField: "new_profile_fw_country",
        },
        {
          code: "A.7",
          machine_name: "new_profile_fw_state",
          widget: "select",
          label: `State <span style="font-size:13.62px">*</span>`,
          selection: data.state,
          state: true,
          maxLength: 35,
          disabled: true,
          disableWhenField: "new_profile_fw_country",
          isVisible: {
            when: "new_profile_fw_country",
            is: ["UNITED STATES OF AMERICA", "- Select -", ""],
            operator: "||",
            hideStyles: true,
          },
          validate: [
            {
              isRequired: "new_profile_fw_country",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          tooltip:
            "Enter the state of the foreign worker’s current residence.  If no state, enter “N/A.”",
        },
        {
          code: "A.8",
          machine_name: "new_profile_fw_postal_code",
          widget: "text",
          label: "Postal Code",
          validate: [
            {
              postalCountry: "new_profile_fw_country",
              needsFieldValues: true,
              extraData: {
                valueOf: "new_profile_fw_country",
              },
            },
            {
              isRequired: "new_profile_fw_country",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
              },
            },
          ],
          disabled: true,
          disableWhenField: "new_profile_fw_country",
          maxLength: 10,
          tooltip:
            "Enter the postal (zip) code of the foreign worker’s current residence.  If no postal code, leave blank.",
        },
        {
          code: "A.10",
          machine_name: "new_profile_fw_province",
          widget: "text",
          label: "Province  §",
          validate: [
            {
              isRequired: "new_profile_fw_country",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "CANADA",
              },
            },
          ],
          maxLength: 25,
          tooltip: `Enter the province of the foreign worker’s current residence.  If no province, enter “N/A.”`,
        },
      ],
    },
    {
      name: "Citizenship",
      fields: [
        {
          code: "A.11",
          machine_name: "new_profile_fw_dob",
          widget: "date",
          label: "Date of Birth (mm/dd/yyyy)",
          validate: ["required", "noNAs", "noFutureDate"],
          maxLength: 70,
          tooltip: `Enter the foreign worker's date of birth.  Use a MM/DD/YYYY format.`,
        },
        {
          code: "A.12",
          machine_name: "new_profile_fw_class",
          widget: "select",
          selection: data.classofAdmission,
          label: "Class of Admission",
          validate: ["required"],
          maxLength: 70,
          tooltip: `Enter the foreign worker’s class of admission at the time of filing (e.g., H-1B, H-2A, etc.).  If no class of admission, enter “N/A.”`,
        },
        {
          code: "A.13",
          machine_name: "new_profile_fw_alien_reg_number",
          widget: "text",
          label: "Alien Registration Number (A#) (if applicable)",
          validate: ["required", "noNAs"],
          maxLength: 11,
          tooltip: `Enter the foreign worker’s alien registration number (A#) assigned by DHS.  If no alien registration number, enter “0” (zero).`,
        },
        {
          code: "A.14",
          machine_name: "new_profile_fw_birth_country",
          widget: "select",
          label: "Country of Birth",
          selection: data.country,
          validate: ["required", "noNAs"],
          maxLength: 70,
          tooltip: `Enter the foreign worker's country of birth.`,
        },
        {
          code: "A.15",
          machine_name: "new_profile_fw_citizen_country",
          widget: "select",
          label: "Country of Citizenship or Nationality",
          selection: data.country,
          validate: ["required", "noNAs"],
          maxLength: 70,
          tooltip: `Enter the foreign worker’s country of current citizenship.`,
        },
        {
          machine_name: "new_group_fw_groups",
          widget: "text",
          hidden: true,
        },
      ],
    },
    {
      isProfileLinkingTable: true,
      type: "foreign-worker",
      linkingType: "foreign-worker-group",
      addButtonText: "Add Foreign Worker Groups to this Profile",
    },
    {
      code: "Appendix A.B",
      machine_name: "new_profile_fw_education",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Foreign Worker Education",
      modalHeader: "Add Foreign Worker Education",
      sectionHeader: "Foreign Worker Education",
      listType: "table",
      editButton: true,
      removeLink: "Remove Foreign Worker Education",
      sortBy: { field: "appAEduMonthYearAttained", type: "date" },
      hide: (formApi) => {
        const fieldArray =
          formApi?.getState()?.values?.new_profile_fw_education || [];
        return fieldArray.some(
          (element) => element?.appAEduTypeId?.toUpperCase() === "NONE"
        );
      },
      modalFields: [
        {
          hideOnTable: false,
          tableHeader: "Education",
          isGroup: {
            code: "1",
            machine_name: "appAEduTypeId",
            required: true,
            label:
              "Education: U.S Diploma/Degree attained relevant to the job opportunity",
            clearBtn: {
              clearSchema: [],
            },
            tooltip:
              "Identify whether the foreign worker’s minimum U.S. diploma or degree, relevant to the job opportunity, is None, High school/GED, Associate, Bachelor’s, Master’s, Doctorate, or Other degree.  Only mark one box.  If no relevant diploma or degree, enter “N/A.”",
            fields: [
              {
                widget: "radio",
                choice: "None",
                value: "None",
                parent_machine_name: "add_values_field",
                clearSchema: fieldsToClearAppAB,
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "High School/GED",
                value: "High School/GED",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Associate",
                value: "Associate",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Bachelor's",
                value: "Bachelor's",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Master's",
                value: "Master's",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Doctorate (PhD)",
                value: "Doctorate (PhD)",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Other Degree (JD, MD, etc.)",
                value: "Other Degree",
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          code: "1.a",
          machine_name: "appAEduOther",
          label:
            'If "Other Degree" in question 1, specify the diploma/degree attained',
          widget: "text",
          hideOnTable: true,
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: ["Other Degree"],
            operator: "compareMultiFieldValuesAND_ORInArray",
          },
          maxLength: 120,
          tooltip:
            "If you marked “Other” in question 1, enter the specific U.S. diploma or degree received (e.g., JD, MD, DDS, foreign equivalent or credentialing service, etc.).  If you did not mark “Other” in question 1, or no relevant diploma/degree, enter “N/A.”",
        },
        {
          code: "1.b",
          machine_name: "appAEduMajors",
          label:
            "Specify major(s) and/or field(s) of study (may list more than one related major and more than one field)",
          tableHeader: "Major",
          widget: "text",
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          maxLength: 120,
          tooltip:
            "Enter the foreign worker’s major(s) and/or field(s) of study for the diploma or degree indicated in question 1.  You may list more than one field and/or more than one related major.  If you marked “None” or “High School” in question 1, or no relevant diploma/degree, enter “N/A.”",
        },
        {
          code: "1.c",
          machine_name: "appAEduInstName",
          label: "Name of Institution that issued the degree/diploma",
          tableHeader: "Institution",
          widget: "text",
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "High School/GED",
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          maxLength: 120,
          tooltip:
            "Enter the name of the institution where the foreign worker received the diploma or degree identified in question 1.  If no relevant diploma/degree, enter “N/A.”",
        },
        {
          code: "1.d",
          machine_name: "appAEduCountryId",
          label: "Name of Country of institution identified in question 1c",
          tableHeader: "Country",
          widget: "select",
          selection: data.country,
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "High School/GED",
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          tooltip:
            "Enter the country of the institution identified in question 1c.  If no relevant diploma or degree, enter “N/A.”",
        },
        {
          code: "1.e",
          machine_name: "appAEduMonthYearAttained",
          label: "Month/year attained",
          tableHeader: "Month/Year",
          widget: "text",
          parse: "monthYear",
          maxLength: 7,
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "High School/GED",
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          validate: [
            "required",
            {
              monthYear: "appATrainingStartDate",
              message: "mm/yyyy format required",
            },
            {
              validMonth: "appAEduMonthYearAttained",
              message: "a valid month is required",
            },
            "noFutureDateTextFields",
          ],
          tooltip:
            "Enter the <u>year</u> the foreign worker received the diploma or degree identified in question 1. Use a full year (MM/YYYY) format. If no relevant diploma or degree, leave blank.",
        },
      ],
    },
    {
      code: "Appendix A.C",
      machine_name: "new_profile_fw_training_qualifications",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Foreign Worker Training",
      modalHeader: "Add Foreign Worker Training",
      sectionHeader: "Foreign Worker Training",
      listType: "table",
      editButton: true,
      removeLink: "Remove Foreign Worker Training",
      hide: (formApi) => {
        const fieldArray =
          formApi?.getState()?.values?.new_profile_fw_training_qualifications ||
          [];
        return fieldArray.some(
          (element) => element?.appATrainingInstName?.toUpperCase() === "N/A"
        );
      },
      modalFields: [
        {
          code: "1",
          machine_name: "appATrainingInstName",
          label: "Name of Institution/School/Training provider",
          widget: "text",
          tableHeader: "Institution",
          validate: ["required"],
          maxLength: 120,
          parent_machine_name: "add_values_field",
          clearSchemaIfNA: fieldsToClearAppAC,
          tooltip:
            "1.	Enter the full name of the institution, school, or training provider that conducted the foreign worker’s training.  If the foreign worker has completed no training, enter “N/A.”",
        },
        {
          code: "1.a",
          machine_name: "appATrainingName",
          label: "Name of training, coursework, experience received",
          tableHeader: "Name of Training",
          widget: "text",
          validate: ["required"],
          isVisible: {
            when: "appATrainingInstName",
            is: "useless",
            operator: "has_value_and_not_na",
          },
          maxLength: 120,
          tooltip: `Enter the name of training, coursework, and/or experience received by the foreign 
            worker with the institution, school, or training provider
             listed in question 1. If the foreign worker has completed no training, enter “N/A.”`,
        },
        {
          code: "1.b",
          machine_name: "appATrainingCert",
          label: "Training/certifications/licenses attained (if applicable)",
          tableHeader: "Certification(s)",
          widget: "text",
          validate: ["required"],
          maxLength: 120,
          isVisible: {
            when: "appATrainingInstName",
            is: "useless",
            operator: "has_value_and_not_na",
          },
          tooltip:
            "Enter any license(s), certificate(s), and certification(s) attained or issued as a result of training, coursework, or experienced received by the foreign worker. If the foreign worker has completed no training, enter “N/A.”",
        },
        {
          code: "1.c",
          machine_name: "appATrainingStartDate",
          label: "Start date of training",
          tableHeader: "Start Date",
          widget: "text",
          maxLength: 7,
          parse: "monthYear",
          validate: [
            {
              monthYear: "appATrainingStartDate",
              message: "mm/yyyy format required",
            },
            {
              monthYearStartEnd: "appATrainingEndDate",
              message: "Start Date must occur before End Date.",
              needsFieldValues: true,
              extraData: {
                isInlineModal: true,
                type: "start",
              },
            },
            {
              validMonth: "appATrainingStartDate",
              message: "a valid month is required",
            },
            "required",
            "noFutureDateTextFields",
          ],
          isVisible: {
            when: "appATrainingInstName",
            is: "useless",
            operator: "has_value_and_not_na",
          },
          tooltip:
            "Enter the month and year the foreign worker began the training, coursework, or experience identified in question 1b. Use a MM/YYYY format. If the foreign worker has completed no training, leave blank.",
        },
        {
          code: "1.d",
          machine_name: "appATrainingEndDate",
          label: "End date of training",
          tableHeader: "End Date",
          widget: "text",
          maxLength: 7,
          parse: "monthYear",
          validate: [
            {
              monthYear: "appATrainingStartDate",
              message: "mm/yyyy format required",
            },
            {
              monthYearStartEnd: "appATrainingStartDate",
              message: "End Date must occur after Start Date.",
              needsFieldValues: true,
              extraData: {
                isInlineModal: true,
                type: "end",
              },
            },
            {
              validMonth: "appATrainingEndDate",
              message: "a valid month is required",
            },
            "required",
            "noFutureDateTextFields",
          ],
          isVisible: {
            when: "appATrainingInstName",
            is: "useless",
            operator: "has_value_and_not_na",
          },
          tooltip:
            "Enter the month and year the foreign worker ended the training, coursework, or experience identified in question 1b.  Use a MM/YYYY format.  If the foreign worker has completed no training, leave blank.",
        },
        {
          code: "1.e",
          machine_name: "appATrainingYearAwd",
          label: "Month/year awarded",
          tableHeader: "Awarded Date",
          widget: "text",
          maxLength: 7,
          parse: "monthYear",
          validate: [
            {
              monthYear: "appATrainingStartDate",
              message: "mm/yyyy format required",
            },
            {
              monthYearStartEnd: "appATrainingEndDate",
              message: "Cannot be before Start Date or End Date",
              needsFieldValues: true,
              extraData: {
                isInlineModal: true,
                type: "end",
              },
            },
            {
              monthYearStartEnd: "appATrainingStartDate",
              message: "Cannot be before Start Date or End Date",
              needsFieldValues: true,
              extraData: {
                isInlineModal: true,
                type: "end",
              },
            },
            {
              validMonth: "appATrainingYearAwd",
              message: "a valid month is required",
            },
            "required",
            "noFutureDateTextFields",
          ],
          isVisible: {
            when: "appATrainingInstName",
            is: "useless",
            operator: "has_value_and_not_na",
          },
          tooltip:
            "Enter the month and year the foreign worker received the license(s), certificate(s), and/or certification(s) as a result of completing the training, coursework, and/or experience identified in question 1b.  Use a MM/YYYY format.  If the foreign worker has completed no training, leave blank.",
        },
      ],
    },
    {
      code: "Appendix A.D",
      machine_name: "new_profile_fw_skills",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Skills, Abilities, and Proficiencies",
      modalHeader: "Skills, Abilities, and Proficiencies",
      sectionHeader: "Skills, Abilities, and Proficiencies",
      listType: "table",
      hide: (formApi) => {
        const fieldArray =
          formApi?.getState()?.values?.new_profile_fw_skills || [];
        return fieldArray.some(
          (element) => element?.appASkillsInstName?.toUpperCase() === "N/A"
        );
      },
      editButton: true,
      removeLink: "Remove Skills, Abilities, and Proficiencies",
      modalFields: [
        {
          code: "1.",
          tableHeader: "Employer/Institution/School/Training Name",
          machine_name: "appASkillsInstName",
          label: "Name of Employer/Institution/School/Training Provider",
          widget: "text",
          validate: [
            {
              isRequired: "appendixADRequired",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: true,
              },
            },
            {
              minLength: 2,
              message: "City must contain at least 2 characters",
            },
          ],
          parent_machine_name: "add_values_field",
          clearSchemaIfNA: fieldsToClearAppAD,
          maxLength: 120,
          tooltip: `1.	Enter the legal business name of the employer or the full name of the institution, school, or training provider from which the foreign worker attained the skills, abilities, and/or proficiencies.  If the foreign worker has no relevant skills, abilities, and/or proficiencies for the minimum requirements of the employer’s job opportunity, enter “N/A.”`,
        },
        {
          code: "1.a.",
          label: "Country",
          machine_name: "appASkillsCountryId",
          widget: "select",
          isInlineModal: true,
          selection: data.country,
          validate: ["required"],
          isVisible: {
            when: "appASkillsInstName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          clearSchema: ["appASkillsStateId", "fwTerritory"],
          tooltip:
            "Enter the country of the employer, institution, school, or training provider where the foreign worker attained the skills, abilities, and/or proficiencies listed in question 1.  If the foreign worker has no relevant skills, abilities, and/or proficiencies for the minimum requirements of the employer’s job opportunity, enter “N/A.”",
        },
        {
          code: "1.b.",
          label: "State, Territory, or Province",
          machine_name: "appASkillsStateId",
          widget: "select",
          selection: data.state,
          state: true,
          tableHeader: "State",
          maxLength: 35,
          validate: ["required"],
          isVisible: {
            when: (formApi) => {
              const countryCheck = ["UNITED STATES OF AMERICA"];
              const country =
                formApi.getState().values.add_values_field?.[0]
                  ?.appASkillsCountryId;
              const neededValue =
                formApi.getState().values.add_values_field?.[0]
                  ?.appASkillsInstName;
              if (!!neededValue && countryCheck.includes(country)) {
                return true;
              }
              return false;
            },
            is: "fwStateSelectCheck",
            operator: "customValidation",
          },
          tooltip:
            "Enter the state, territory, or province of the employer, institution, school, or training provider from which foreign worker attained the skills, abilities, and/or proficiencies listed in question 1.  If the foreign worker has no relevant skills, abilities, and/or proficiencies for the minimum requirements of the employer’s job opportunity, enter “N/A.”",
        },
        {
          code: "1.b.",
          machine_name: "fwTerritory",
          label: "State, Territory, or Province",
          tableHeader: "Territory/Province",
          widget: "text",
          validate: [
            "required",
            {
              minLength: 2,
              message: "State must contain at least 2 characters",
            },
          ],
          isVisible: {
            when: (formApi) => {
              const countryCheck = [
                "UNITED STATES OF AMERICA",
                "- Select -",
                null,
                undefined,
              ];
              const country =
                formApi.getState().values.add_values_field?.[0]
                  ?.appASkillsCountryId;
              const neededValue =
                formApi.getState().values.add_values_field?.[0]
                  ?.appASkillsInstName;
              if (!!neededValue && !countryCheck.includes(country)) {
                return true;
              }
              return false;
            },
            is: "fwStateTextCheck",
            operator: "customValidation",
          },
          maxLength: 120,
          tooltip: `Enter the state, territory, or province of the employer, institution, school, or training provider from which foreign worker attained the skills, abilities, and/or proficiencies listed in question 1.  If the foreign worker has no relevant skills, abilities, and/or proficiencies for the minimum requirements of the employer’s job opportunity, enter “N/A.”`,
        },
        {
          code: "1.c.",
          machine_name: "appASkillsSpecial",
          hideOnTable: true,
          label:
            "Description of specific skills, abilities, and/or proficiencies the foreign worker possesses or attained, which help establish whether the foreign worker meets the requirements identified for the job opportunity. (up to 1,500 characters)",
          tooltip:
            "In the space provided (up to 1,500 characters), enter a brief description of specific skills, abilities, and/or proficiencies the foreign worker attained for the minimum requirements of the employer’s job opportunity.  If the foreign worker has no relevant skills, abilities, and/or proficiencies for the minimum requirements of the employer’s job opportunity, enter “N/A.”",
          widget: "text_area",
          validate: [
            "required",
            {
              minLength: 5,
            },
          ],
          isVisible: {
            when: "appASkillsInstName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          inputLimit: 1500,
          width: 8,
          rows: 8,
        },
      ],
    },
    {
      code: "Appendix A.E",
      machine_name: "new_profile_fw_work_experience",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Foreign Worker Work Experience",
      modalHeader: "Add Foreign Worker Work Experience",
      sectionHeader: "Foreign Worker Work Experience",
      listType: "table",
      hide: (formApi) => {
        const fieldArray =
          formApi?.getState()?.values?.new_profile_fw_work_experience || [];
        return fieldArray.some(
          (element) => element?.appAExpEmpName?.toUpperCase() === "N/A"
        );
      },
      editButton: true,
      removeLink: "Remove Foreign Worker Work Experience",
      modalFields: [
        {
          code: "1",
          machine_name: "appAExpEmpName",
          label: "Employer Name",
          widget: "text",
          tableHeader: "Employer Name",
          validate: [
            {
              isRequired: "appendixAERequired",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: true,
              },
            },
          ],
          parent_machine_name: "add_values_field",
          clearSchemaIfNA: fieldsToClearAppAE,
          maxLength: 120,
          tooltip:
            "Enter the full legal name of the business, person, association, firm, corporation, or organization, i.e., the employer that employed the foreign worker.  If the foreign worker does not have any relevant work experience, enter “N/A.”",
        },
        {
          code: "1.a",
          machine_name: "appAExpAddress1",
          label: "Address 1",
          widget: "text",
          hideOnTable: true,
          validate: [
            "required",
            {
              minLength: 2,
              message: `Address 1 must contain at least 2 characters.`,
            },
          ],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          maxLength: 60,
          tooltip:
            "Enter the street address of the employer identified in question 1.  If the foreign worker does not have any relevant work experience, enter “N/A.”",
        },
        {
          code: "1.b",
          machine_name: "appAExpAddress2",
          label: "Address 2",
          widget: "text",
          hideOnTable: true,
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          maxLength: 60,
          tooltip:
            "Enter additional information about the street address of the employer identified in question 1.  If the foreign worker does not have any relevant work experience, or no additional space is needed, enter “N/A.”",
        },
        {
          code: "1.c",
          machine_name: "appAExpCity",
          label: "City or Town",
          widget: "text",
          hideOnTable: true,
          validate: [
            "required",
            {
              minLength: 2,
              message: "City must contain at least 2 characters.",
            },
          ],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          maxLength: 35,
          tooltip:
            "Enter the city or town of the employer identified in question 1.  If the city and country are the same, the name <u>must</u> still be entered in <u>both</u> fields.  If the foreign worker does not have any relevant work experience, enter “N/A.”",
        },
        {
          code: "1.d",
          machine_name: "appAExpPostalCode",
          label: "Postal Code",
          widget: "text",
          hideOnTable: true,
          validate: [
            {
              isRequired: "appAExpCountryId",
              message: "This field is required",
              needsFieldValues: true,
              extraData: {
                valueOf: "UNITED STATES OF AMERICA",
                isInlineModal: true,
              },
            },
          ],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          maxLength: 10,
          tooltip:
            "Enter the postal (zip) code of the employer identified in question 1.  If the foreign worker does not have any relevant work experience, or the postal code is not known or does not exist, leave blank.",
        },
        {
          code: "1.e",
          machine_name: "appAExpCountryId",
          label: "Country",
          tableHeader: "Country",
          widget: "select",
          isInlineModal: true,
          clearSchema: ["appAExpStateTerritory", "appAExpProvince"],
          selection: data.country,
          validate: ["required"],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          tooltip: `Enter the country of the employer identified in question 1.  If the city and country
             are the same, the name <u>must</u> still be entered in <u>both</u> fields.  If the foreign
              worker does not have any relevant work experience, enter “N/A.”`,
        },
        {
          code: "1.f",
          label: "State, Territory, or Province",
          machine_name: "appAExpStateTerritory",
          widget: "select",
          selection: data.state,
          state: true,
          hideOnTable: true,
          maxLength: 35,
          validate: ["required"],
          isVisible: {
            when: (formApi) => {
              const countryCheck = ["UNITED STATES OF AMERICA"];
              const country =
                formApi.getState().values.add_values_field?.[0]
                  ?.appAExpCountryId;
              const neededValue =
                formApi.getState().values.add_values_field?.[0]?.appAExpEmpName;
              if (!!neededValue && countryCheck.includes(country)) {
                return true;
              }
              return false;
            },
            is: "fwStateSelectCheck",
            operator: "customValidation",
          },
          tooltip:
            "Enter the state, territory, or province of the employer identified in question 1.  If the foreign worker does not have any relevant work experience, or no state, territory, or province exists, enter “N/A.”",
        },
        {
          code: "1.f",
          label: "State, Territory, or Province",
          machine_name: "appAExpProvince",
          widget: "text",
          hideOnTable: true,
          maxLength: 35,
          validate: ["required", { minLength: 2 }],
          isVisible: {
            when: (formApi) => {
              const countryCheck = [
                "UNITED STATES OF AMERICA",
                "- Select -",
                null,
                undefined,
              ];
              const country =
                formApi.getState().values.add_values_field?.[0]
                  ?.appAExpCountryId;
              const neededValue =
                formApi.getState().values.add_values_field?.[0]?.appAExpEmpName;
              if (!!neededValue && !countryCheck.includes(country)) {
                return true;
              }
              return false;
            },
            is: "fwStateTextCheck",
            operator: "customValidation",
          },
          tooltip: `Enter the state, territory, or province of the employer identified
             in question 1.  If the foreign worker does not have any relevant
              work experience, or no state, territory, or province exists, enter “N/A.”`,
        },
        {
          code: "1.g",
          machine_name: "appAExpJobTitle",
          label: "Job Title",
          widget: "text",
          tableHeader: "Job Title",
          validate: ["required"],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          maxLength: 60,
          tooltip:
            "Enter the foreign worker’s job title with the employer identified in question 1.  If the foreign worker does not have any relevant work experience, enter “N/A.”",
        },
        {
          code: "1.h",
          machine_name: "appAExpStartDate",
          label: "Start Date",
          hideOnTable: true,
          widget: "text",
          maxLength: 7,
          parse: "monthYear",
          validate: [
            "required",
            {
              monthYear: "appAExpStartDate",
              message: "mm/yyyy format required",
            },
            {
              monthYearStartEnd: "appAExpEndDate",
              message: "Start Date must occur before End Date.",
              needsFieldValues: true,
              extraData: {
                isInlineModal: true,
                type: "start",
              },
            },
            {
              validMonth: "appAExpStartDate",
              message: "a valid month is required",
            },
            "noFutureDateTextFields",
          ],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          tooltip:
            "Enter the month and year the foreign worker started working for the employer identified in question 1.  Use a MM/ YYYY format.  If the foreign worker does not have any relevant work experience, enter “N/A.”",
        },
        {
          code: "1.i",
          machine_name: "appAExpEndDate",
          label: "End Date",
          hideOnTable: true,
          widget: "text",
          maxLength: 7,
          parse: "monthYear",
          validate: [
            "required",
            {
              monthYear: "appAExpEndDate",
              message: "mm/yyyy format required",
            },
            {
              monthYearStartEnd: "appAExpStartDate",
              message: "End Date must occur after Start Date.",
              needsFieldValues: true,
              extraData: {
                isInlineModal: true,
                type: "end",
              },
            },
            {
              validMonth: "appAExpEndDate",
              message: "a valid month is required",
            },
            "noFutureDateTextFields",
          ],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          tooltip:
            "Enter the month and year the foreign worker stopped working or ended employment with the employer identified in question 1.  Use a MM/YYYY format.  If the foreign worker does not have any relevant work experience, leave blank.",
        },
        {
          hideOnTable: true,
          isGroup: {
            code: "1.j",
            machine_name: "appAExpFWPresent",
            required: true,
            label: "Present",
            isVisible: {
              when: "appAExpEmpName",
              is: "useless", // useless field, needed to fire isVisible cond
              operator: "has_value_and_not_na",
            },
            clearBtn: {
              clearSchema: [""],
            },
            tooltip:
              "Mark “Yes” to indicate that the foreign worker is currently working for the employer identified in question 1.  If the foreign worker is <u>not</u> currently working with the employer identified in question 1, mark “No.”  If the foreign worker does not have any relevant work experience, leave blank.",
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "Yes",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "No",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "1.k",
          machine_name: "appAExpWorkHour",
          label: "Hours Worked Per Week",
          widget: "text",
          hideOnTable: true,
          validate: ["number"],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          maxLength: 3,
          tooltip:
            "Enter the normal number of hours the foreign worker worked per week while working for the employer identified in question 1.  If the foreign worker does not have any relevant work experience, leave blank.",
        },
        {
          code: "1.l",
          machine_name: "appAExpJobDuties",
          label: `Job Duties: Specify details of the job work (work tasks performed, use of 
            tools/equipment, supervision, etc.) (up to 3,500 characters)`,
          widget: "text_area",
          hideOnTable: true,
          validate: [
            "required",
            {
              minLength: 5,
            },
          ],
          isVisible: {
            when: "appAExpEmpName",
            is: "useless", // useless field, needed to fire isVisible cond
            operator: "has_value_and_not_na",
          },
          minLength: 5,
          inputLimit: 3500,
          tooltip:
            "Enter a description of the job duties the foreign worker performed while working for the employer identified in question 1.  Include work done, managerial or supervisory functions performed, equipment and tools used, materials or products handled, and all other relevant information (up to 3,500 characters).  <b><i>The description must be completed in the space provided</i></b>.  If the foreign worker does not have any relevant work experience, enter “N/A.”",
        },
      ],
    },
    {
      name: "Profile Name",
      coloring: "blue",
      fields: [
        {
          machine_name: "new_profile_fw_profile_name",
          widget: "text",
          label: "What would you like to name this profile?",
          validate: ["required"],
          maxLength: 60,
          tooltip:
            "Enter a unique name that will allow you to identify this profile",
        },
      ],
    },
  ],
};
